module.exports = __webpack_public_path__ + "static/media/editIconActive.f2c71633.svg";